<template>
<div>
</div>
</template>

<script>
import { useClient, useMutation } from 'villus';
import { gql } from 'graphql-tag';
import { computed, reactive } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'validateAnswersMutation',

  setup() {
    const store = useStore();

    useClient({
      url: process.env.VUE_APP_STRAPI,
    });

    const validateAnswersMutation = gql`
      mutation($questionId: ID!) {
        validateAnswers(questionId: $questionId) {
          correctIds
        }
      }
      `;

    const context = reactive({
      headers: computed(() => store.state.auth.headers),
    });

    const { execute: validateAnswers } = useMutation(validateAnswersMutation, {
      context,
    });

    store.commit('setStrapiExecutionHandler', { item: 'validateAnswers', result: validateAnswers });
  },
};
</script>
